export const TRACK_CATEGORY = 'UI::TerraformPackages';
